import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_o3krv3vw6u: FaireBrandEntity = {
  token: "b_o3krv3vw6u",
  type: "brand",
  name: "KORRES USA LTD",
  avatarUrl:
    "https://cdn.faire.com/fastly/420467155691682b0d8dd3147936dfbcc8e84b5bef7dba2b1113ea3e07eaa039.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/4802e58990b7c08bf5dc650278770ef9c22aba5b55cb61bf419d9f512d755024.png",
  logoUrl:
    "https://cdn.faire.com/fastly/420467155691682b0d8dd3147936dfbcc8e84b5bef7dba2b1113ea3e07eaa039.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/4802e58990b7c08bf5dc650278770ef9c22aba5b55cb61bf419d9f512d755024.png",
  location: "NY, USA",
  minimumOrderDollars: 200,
  rating: 4.9,
  reviewCount: 34,
  isTopShop: true,
  isInsider: true,
  description:
    "Born out of the oldest homeopathic pharmacy in Athens, Greece over 25 years ago, KORRES is the leading seed-to-skin skincare brand dominating the US clean skincare market today.  Inspired by generations-old traditions, we blend the most potent Greek ingredients with cutting-edge technologies and science for results you can see and feel both instantly and long-term.",
  meta: {
    source: "api",
    importedAt: "2026-07-06T18:02:45.472Z",
    importedBy: "entity-db-cli",
  },
};
